import Coffee from './coffee';
import Dispatche from './dispatche';
import Employee from './employee';
import OfficeAutomation from './office-automation';
import Store from './store';
import Community from './community';
import Kiosk from './kiosk';

export default {
  Coffee,
  Dispatche,
  Employee,
  OfficeAutomation,
  Store,
  Community,
  Kiosk,
};
